var url = {
  api: 'https://tcbp.hsqh.net:8443/', // 正式地址
  api1: 'http://47.103.11.238:9444/', // 测试地址
  // api2: 'http://47.103.11.238:8890/', // 正式地址(废弃)
  api3: 'https://tcbp.hsqh.net:9553/', // 正式地址3 (交割园地-智能客服), 打开微信小程序
  api4: 'https://www.simnow.com.cn/', // 模拟交易大赛报名系统正式地址
  // api5: 'https://218.202.237.33:8443/', // 模拟交易大赛报名系统测试地址
  api5: 'https://tcbp.hsqh.net:8443/', // 模拟交易大赛报名系统

  // api6: 'http://192.168.116.56:9092/user/service/key/hsSimService/', // 模拟交易大赛报名系统---wyl------测试
  // api7: 'http://192.168.116.56:9092/', // 模拟交易大赛报名系统---wyl---测试（包括录入数据传给app后台）

  api6: 'https://multiapp.hsqh.net:4443/user/service/key/hsSimService/', // 模拟交易大赛报名系统---wyl-------生产
  api7: 'https://multiapp.hsqh.net:4443/', // 模拟交易大赛报名系统---wyl---生产

  // api8: 'http://47.103.11.238:9333/api/hsqh/wx/', // 预约开户---dy---测试
  api8: 'https://tcbp.hsqh.net:8443/api/hsqh/wx/' // 预约开户---dy---生产

}
export default url



// WEBPACK FOOTER //
// ./src/config/url.js